export default __webpack_public_path__ + "static/media/Seven.4571e577.svg";